import { useContext } from "react";
import { LanguageContext } from "../../../context/LanguageContext";
import { ParagraphText } from "../../../Libraries";
import styles from "./AddQuickHeader.module.css";

const AddQuickHeader = ({ required = false }) => {
  const [I18n] = useContext(LanguageContext);
  return (
    <div className={`${styles.headRow} invoiceItemTableHeadRow`}>
      <div
        className={`${styles.headCell} ${styles.headCellItem} invoiceItemTableHeadCell`}
      >
        <ParagraphText className="fontSize14 blue800Color">
          {I18n.item} {required && <span className="foundationErrorRed">*</span>}
        </ParagraphText>
      </div>
      <div
        className={`${styles.headCell} ${styles.headCellQty} invoiceItemTableHeadCell`}
      >
        <ParagraphText className="fontSize14 blue800Color">
          {I18n.quantity}
        </ParagraphText>
      </div>
      <div
        className={`${styles.headCell} ${styles.headCellPrice} invoiceItemTableHeadCell`}
      >
        <ParagraphText className="fontSize14 blue800Color">
          {I18n.unit_price}
        </ParagraphText>
      </div>
    </div>
  );
};
export default AddQuickHeader;